import {
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle,
  Label,
} from "reactstrap";
import { CloseIcon, FilterIcon, filterBlackIcon } from "../../../assets/images";
import { DropDown } from "../../commons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  invoiceTypeDropDown,
  transactionAmountLimitDropdown,
  transactionAmountTypeDropDown,
} from "../../../constant/reports/ledgerStatementConstant";
import { LedgerStatementType } from "../../../redux/reports/reportsType";
import "./LedgerStatementFilter.scss";

type FilterMultiSelectDataType = {
  invoiceType: { label: string; value: number | null };
  transactionAmountType: { label: string; value: string | null };
  transactionAmountLimitType?:
    | { label: string; value: string | null }
    | undefined;
  value: string;
};

type AppProps = {
  toggle: boolean;
  setToggle: (data: boolean) => void;
  filterValue: any;
  setFilterValue: any;
  handleApplyFilter: () => void;
  handleFilterClear: () => void;
  multiSelectData: FilterMultiSelectDataType;
  ledgerStatement: [] | LedgerStatementType[];
};

const LedgerStatementFilter = ({
  toggle,
  setToggle,
  filterValue,
  setFilterValue,
  handleFilterClear,
  handleApplyFilter,
  multiSelectData,
  ledgerStatement,
}: AppProps) => {
  const filterCount: number = Object.values(multiSelectData).filter((e: any) =>
    e?.hasOwnProperty("value")
      ? e?.value?.toString()?.length > 0
      : e?.toString()?.length > 0
  ).length;
  const clearFilter = () => {
    resetFilter();
    handleFilterClear();
  };

  const empty = () => {
    // setFilterValue({ user: { label: "", value: null } });
  };

  const resetFilter = () => {
    setFilterValue({
      invoiceType: { label: "", value: null },
      transactionAmountType: { label: "", value: null },
    });
  };

  const isApplyDisabled = () => {
    if (filterValue?.transactionAmountLimitType?.value) {
      return !filterValue?.value;
    }
    return false;
  };
  const handleTransactionAmountType = (e: any) => {
    setFilterValue((prev: any) => ({
      ...prev,
      transactionAmountType: e,
    }));

    setFilterValue((prev: any) => ({
      ...prev,
      transactionAmountLimitType: "",
    }));
    setFilterValue((prev: any) => ({
      ...prev,
      value: "",
    }));
  };
  const handleTransactionAmountLimit = (e: any) => {
    setFilterValue((prev: any) => ({
      ...prev,
      transactionAmountLimitType: e,
    }));
    setFilterValue((prev: any) => ({
      ...prev,
      value: e?.value !== "" ? prev?.value : "",
    }));
  };
  const isFilterDisabled = !ledgerStatement?.length;
  return (
    <ButtonDropdown
      isOpen={toggle}
      // disabled={isFilterDisabled}
      toggle={() => {
        filterCount === 0 && toggle ? resetFilter() : empty();
        setToggle(!toggle);
      }}
    >
      <OverlayTrigger
        placement="bottom"
        delay={{ show: 250, hide: 250 }}
        overlay={<Tooltip id="button-view-download-invoice">Filter</Tooltip>}
      >
        <DropdownToggle
          caret
          color="#262a44"
          style={{
            border: "1px solid #bfcbe1",
            backgroundColor: "#ffffff",
            color: "#262a44",
            height: "38px",
            cursor: "pointer",
          }}
        >
          <img src={filterCount !== 0 ? FilterIcon : filterBlackIcon} alt="" />
          <span className={filterCount !== 0 ? "filter-count" : ""}>
            <span>{filterCount !== 0 ? filterCount : ""}</span>
          </span>
        </DropdownToggle>
      </OverlayTrigger>
      <DropdownMenu right style={{ width: "400px", padding: "15px 25px 30px" }}>
        <div className="d-flex justify-content-between mt-0 mb-0">
          <h5 className="text-center ">Filter</h5>
          <div
            className="pointer"
            onClick={() => {
              setToggle(!toggle);
            }}
          >
            <img src={CloseIcon} alt="" />
          </div>
        </div>
        <hr className="mt-0 mb-2" />

        <div className="col-md-12 ">
          <label htmlFor="entity">Invoice Type</label>
          <div>
            <DropDown
              options={
                invoiceTypeDropDown
                  ? [{ value: "", label: "Select..." }, ...invoiceTypeDropDown]
                  : [{ value: "", label: "Select..." }]
              }
              value={
                filterValue?.invoiceType?.value
                  ? filterValue?.invoiceType
                  : "Select"
              }
              handleChange={(e) =>
                setFilterValue((prev: any) => ({ ...prev, invoiceType: e }))
              }
            />
          </div>
        </div>
        <div className="col-md-12 mt-3">
          <label htmlFor="entity">Transaction Amount Type</label>
          <div>
            <DropDown
              options={
                transactionAmountTypeDropDown
                  ? [
                      { value: "", label: "Select..." },
                      ...transactionAmountTypeDropDown,
                    ]
                  : [{ value: "", label: "Select..." }]
              }
              value={
                filterValue?.transactionAmountType?.value
                  ? filterValue?.transactionAmountType
                  : "Select"
              }
              handleChange={(e) => handleTransactionAmountType(e)}
            />
          </div>
        </div>
        {filterValue?.transactionAmountType?.value ? (
          <div className="col-md-12 mt-3">
            <label htmlFor="entity">Transaction Amount Limit</label>

            <div className="filter-row">
              <div className="dropdown-container">
                <DropDown
                  options={
                    transactionAmountLimitDropdown
                      ? [
                          { value: "", label: "Select..." },
                          ...transactionAmountLimitDropdown,
                        ]
                      : [{ value: "", label: "Select..." }]
                  }
                  value={
                    filterValue?.transactionAmountLimitType?.value
                      ? filterValue?.transactionAmountLimitType
                      : "Select"
                  }
                  handleChange={(e) => handleTransactionAmountLimit(e)}
                />
              </div>
              <div className="input-container">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Enter Amount..."
                  value={filterValue?.value}
                  onChange={(e) =>
                    setFilterValue((prev: any) => ({
                      ...prev,
                      value: e.target.value,
                    }))
                  }
                  disabled={!filterValue?.transactionAmountLimitType?.value}
                />
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="d-flex align-items-center justify-content-end mt-3">
          <button
            className="mr-2 btn btn-outline"
            onClick={() => {
              clearFilter();
              setToggle(!toggle);
            }}
          >
            Clear Filter
          </button>
          <button
            className="pl-4 pr-4 btn btn-primary"
            onClick={() => {
              handleApplyFilter();
              setToggle(!toggle);
            }}
            disabled={isApplyDisabled()}
          >
            Apply
          </button>
        </div>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default LedgerStatementFilter;
